import {
	ComCustomerCommerceRestOrderHandlerPlaceOrder,
	ComCustomerCommerceRestOrderHandlerPlaceOrderProcessBodyParameterDescription,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class PlaceOrder<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;
	traceDetails: string | undefined;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
		this.traceDetails = process.env.TRACE_DETAILS?.trim();
	}

	/**
	 * No description
	 *
	 * @tags PlaceOrder
	 * @name PlaceOrder
	 * @summary Place order.
	 * @request POST:/store/{storeId}/fca/order/place/{orderId}
	 * @secure
	 * @response `200` `ComCustomerCommerceRestOrderHandlerPlaceOrder` The requested completed successfully.
	 * @response `400` `void` Bad request. Some of the inputs provided to the request aren't valid.
	 * @response `401` `void` Not authenticated. The user session isn't valid.
	 * @response `403` `void` The user isn't authorized to perform the specified request.
	 * @response `404` `void` The specified resource couldn't be found.
	 * @response `500` `void` Internal server error. Additional details will be contained on the server logs.
	 */
	placeOrder = (
		storeId: string,
		orderId: string,
		data: ComCustomerCommerceRestOrderHandlerPlaceOrderProcessBodyParameterDescription,
		params: RequestParams = {}
	) => {
		const { _requestId: requestId } = params as any;
		delete (params as any)._requestId;

		if (loggerCan('trace') && (!this.traceDetails || this.traceDetails.includes('placeOrder'))) {
			const paramsLogger = logger.child({
				params,
				query: null ?? {},
				body: data ?? {},
				methodName: 'placeOrder',
				requestId,
			});
			paramsLogger.trace('API request parameters');
		}
		return this.http.request<ComCustomerCommerceRestOrderHandlerPlaceOrder, void>({
			path: `/store/${storeId}/fca/order/place/${orderId}`,
			method: 'POST',
			body: data,
			secure: true,
			type: params.type ?? ContentType.Json,
			format: params.format ?? 'json',
			storeId,
			...params,
		});
	};
}
